import { CircularProgress, Grid, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import AutoComplete from 'components/AutoComplete';
import InputField from 'components/InputField';
import { translate } from 'helpers/intl';
import useOrganizations from 'hooks/organizations/useOrganizations';
import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { isDrpp, isNumAdhesion } from 'utils/amcUtils';
import messages from '../messages';
import RenderOption from './RenderOption';
import SelectOrganizationText from './SelectOrganizationText';
import useStyles from './styles';
import { buildOptions, ORGANIZATION } from './utils';
interface Props {
  intl: IntlShape;
  organization: any;
  membershipNumber: string;
  drpp: string;
  cin?: string;
  touched: any;
  errors: any;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (key: string, value: any) => void;
  displayCin?: boolean;
}

const HealthInsuranceFields = ({
  setFieldValue,
  handleChange,
  drpp,
  organization,
  membershipNumber,
  errors,
  touched,
  displayCin = false,
  cin,
  ...props
}: Props) => {
  const [inputText, setInputText] = useState<string>('');
  const styles = useStyles();
  const { data, loading } = useOrganizations({
    lazy: false,
    resetOnUnmount: false,
  });

  if (loading)
    return (
      <Grid container justify="center">
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    );

  return (
    <Grid container direction="column" spacing={3} justify="center">
      <Grid item xs={12}>
        <AutoComplete
          loading={loading}
          name={ORGANIZATION}
          // label={translate(messages.selectOrganization, props)}
          placeholder={translate(messages.searchOrganization, props)}
          onChange={(value) => {
            setInputText('');
            setFieldValue(ORGANIZATION, value);
          }}
          value={organization}
          options={buildOptions(data, inputText)}
          getOptionLabel={(option) => option.subscriber}
          renderOption={({ policyNumber, subscriber }) => (
            <RenderOption policyNumber={policyNumber} subscriber={subscriber} />
          )}
          onInputChange={setInputText}
          noOptionsText={
            <SelectOrganizationText
              Icon={inputText.length > 2 ? CloseIcon : SearchIcon}
              Body={
                inputText.length > 2 ? (
                  <>
                    <Typography className={styles.text}>
                      {translate(messages.noOrganizationFound, props)}
                    </Typography>
                    <Typography className={styles.text}>
                      {translate(messages.tryAgain, props)}
                    </Typography>
                  </>
                ) : (
                  <Typography className={styles.text}>
                    {translate(messages.selectOrganizationMinCar, props)}
                  </Typography>
                )
              }
            />
          }
          error={touched.organization && errors.organization}
          helperText={touched.organization && errors.organization}
        />
      </Grid>
      {isDrpp(organization?.isdrpp) && (
        <Grid item xs={12} data-testid="drpp">
          <InputField
            name="drpp"
            label={translate(messages.drppNumber, props)}
            value={drpp}
            handleChange={handleChange}
            error={touched.drpp && errors.drpp}
            helperText={touched.drpp && errors.drpp}
          />
        </Grid>
      )}
      {isNumAdhesion(organization?.numAdhesion, organization?.isdrpp) && (
        <Grid item xs={12} data-testid="membershipNumber">
          <InputField
            name="membershipNumber"
            label={translate(
              organization?.isdrpp === 'Matricule'
                ? messages.membershipMatricul
                : messages.membershipNumber,
              props,
            )}
            value={membershipNumber}
            handleChange={handleChange}
            error={touched.membershipNumber && errors.membershipNumber}
            helperText={touched.membershipNumber && errors.membershipNumber}
          />
        </Grid>
      )}

      {displayCin &&
        organization &&
        !isNumAdhesion(organization?.numAdhesion, organization?.isdrpp) &&
        !isDrpp(organization?.isdrpp) && (
          <Grid item xs={12} data-testid="cin">
            <InputField
              name="cin"
              label={translate(messages.yourCinNumber, props)}
              value={cin || ''}
              handleChange={handleChange}
              error={touched.cin && errors.cin}
              helperText={touched.cin && errors.cin}
            />
          </Grid>
        )}
    </Grid>
  );
};

HealthInsuranceFields.propTypes = {};

export default injectIntl(HealthInsuranceFields);
